module.exports = __webpack_public_path__ + "assets/img/n5.fcdff1fa.png";